import { utils } from 'ui-common';
import baseRequest from './baseRequest';

const { featureFlags } = utils;

export function getPrivacyPolicyTextScreenId() {
  return featureFlags.isEnabled('tosPrivacyUpdate20190320') ? 'blend-privacy-policy-new' : 'blend-privacy-policy';
}

export function getPrivacyPolicy() {
  const privacyPolicyId = getPrivacyPolicyTextScreenId();
  return baseRequest.get(`/api/text-screens/${privacyPolicyId}`);
}
